export const environment = {
  production: false,
  // apiBase: 'http://127.0.0.1:8000',
  apiBase: 'https://cshapps-api.mavenepm.com',

  xApiToken: 'MktMO8tCAKkh2YGNLKIU11vHh5062QUKZ',
  apiVersion: 'v1',

  appLogo: 'healthVault',
  appName: 'client',
  appVersion: '3.0.1',
  role: 'client',

  SOCKET_ENDPOINT: 'https://websocket.mavenepm.com/',
  teleconsultLinks: {
    provider: 'https://teleconsult.mavenepm.com/teleconsult/',
    client: 'https://teleconsult.mavenepm.com/consult/',
  },
};
